export default __webpack_public_path__ + "static/media/Cloud-background.f88244c2.png";